'use strict';

angular.module('app').directive('youtubeVideo', function($compile, $http) {
    return function(scope, elem, attrs) {
        $(elem).on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.youtube-video').first().click();
        });

        $('.youtube-video').fancybox({
            type: 'html',
            padding: ['20', '50', '80', '50'],
            wrapCSS: 'photo-gallery video-gallery',
            fitToView: true,
            hideOnOverlayClick: false,
            maxWidth: attrs.maxWidth,
            type: 'swf',
            helpers: {
                overlay: {
                    locked: true,
                    closeClick: false,
                    css: {
                        background: 'rgba(0,0,0,0.9)'
                    }
                },
                media: {}
            }
        });
    };
});